import { render, staticRenderFns } from "./AccordionWeeklyProgress.vue?vue&type=template&id=641e318f&scoped=true"
import script from "./AccordionWeeklyProgress.vue?vue&type=script&lang=js"
export * from "./AccordionWeeklyProgress.vue?vue&type=script&lang=js"
import style0 from "./AccordionWeeklyProgress.vue?vue&type=style&index=0&id=641e318f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e318f",
  null
  
)

export default component.exports